let World = require('../game_logic/world');

class LogicBridge {
  constructor (game) {
    this.world = new World(this.removeCountry.bind(this),10000);
    this.countries = {
      "top-left": {
        country: this.world.countries[0]
      },
      "bottom-left": {
        country: this.world.countries[1]
      },
      "top-right": {
        country: this.world.countries[2]
      },
      "bottom-right": {
        country: this.world.countries[3]
      },
    };
    this.game = game;
    this.player = game.player;
    this.setUpGame(this.countries);
  }

  advanceGeneration (humanPlayer,modifiers) {
    for (let i = 0; i < 5; i++) {
      this.world.cycleUp(humanPlayer);
    }
    this.game.ageUp();
  }

  introduceChangeToCountry (country) {

  }

  removeCountry(country) {
    this.game.removeCountry(country);
  }

  initiateBattle (attacker, defender, resizeCountry) {
    // Don't forget cannon bonus
    let attackerSoldiers = attacker.object.soldiers,
      defenderSoldiers = defender.object.soldiers *
        defender.object.homeMilitary +
        Math.floor(defender.object.workers * 0.5 *
        defender.object.bonuses.militia),
      attackerStrength = 1000 + attackerSoldiers *
        Math.pow(attacker.object.avgStr,2) * attacker.object.militaryTech *
        attacker.object.bonuses.soldiersTrained,
      defenderStrength = 1000 + defenderSoldiers *
        Math.pow(defender.object.avgStr,2) * defender.object.militaryTech *
        defender.object.bonuses.soldiersTrained *
        defender.object.bonuses.defenses * 1.5,
      relativeStrength = Math.min((attackerStrength / defenderStrength) *
        (attacker.object.techPower / defender.object.techPower),5),
      capturedLand = defender.object.size * 0.1 * relativeStrength /
        ((defender.object.numTargeted + 1) / 2),
      attackerCasualties = Math.floor((attackerSoldiers * 0.2) /
        this.limitCasualties(relativeStrength)),
      defenderCasualties = Math.floor((defenderSoldiers * 0.1) *
        this.limitCasualties(relativeStrength)),
      capturedFood = defender.object.foodStorage * 0.3 * (relativeStrength / 5);

    let results = {
      relativeStrength: relativeStrength,
      capturedLand: capturedLand,
      capturedFood: capturedFood,
      attackerCasualties: attackerCasualties,
      defenderCasualties: defenderCasualties,
      aggressor: attacker
    };
    [attacker, defender].forEach(country => country.object.assessDamages(results));
  }

  limitCasualties (relativeStrength) {
    if (relativeStrength > 2) {
      return 2;
    } else if (relativeStrength < 0.5) {
      return 0.5;
    } else {
      return relativeStrength;
    }
  }

  setUpGame () {
    this.game.setUpGame (this.countries);
  }
}

module.exports = LogicBridge;



/*****************
 ** WEBPACK FOOTER
 ** ./game/handlers/logic_bridge.js
 ** module id = 11
 ** module chunks = 0
 **/